export const isValidEmail = (email: string): boolean => {
	const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
	return emailPattern.test(email)
}
